/**
 * @fileoverview Bootstrap React de la console GNPC.
 *
 * Point d'entrée référencé par `index.html`. Monte l'application dans
 * l'élément `#root`, active `StrictMode` (double rendering en dev pour
 * détecter les effets non idempotents — important vu que la console
 * fait des mutations financières via `payment:replay` et refunds).
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import './styles/main.css';

const rootElement = document.getElementById('root');

if (!rootElement) {
  // Impossible en pratique (voir `index.html` : le div est toujours là),
  // mais on préfère un crash explicite à un `!` non-null assertion
  // silencieux qui masquerait un vrai bug de build.
  throw new Error('Élément #root introuvable dans le DOM — vérifier index.html.');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
